import ArrayFieldTemplate from './ArrayFieldTemplate';
import FieldTemplate from './FieldTemplate';
import ObjectFieldTemplate from './ObjectFieldTemplate';

export default {
  ArrayFieldTemplate,
  FieldTemplate,
  ObjectFieldTemplate,
};
